// APY params
export const EXP_SCALE = 1e18
export const YEAR_MS = 60 * 60 * 24 * 365
// export const UTILIZATION_RATE = [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
export const UTILIZATION_RATE = new Array(101).fill(0).map((item, i) => i * 0.01)

// unlimited approve amount
export const UNLIMITED_APPROVE_AMOUNT = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'

export const DEFAULT_ADDRESS = '0x1C41d30CaAacd3B30678fCDB3eD952B06a82E78E'.toLowerCase() // for no wallet connect address

export const UnknowError = 'Unknow Error'

export const CCIP_EXPLORER = 'https://ccip.chain.link'
export const LAYERZERO_TESTNET_SCAN = 'https://testnet.layerzeroscan.com'
export const LAYERZERO_SCAN = 'https://layerzeroscan.com'

export const SHYLOCK_BASE_URL = 'https://api-shylock.sumer.money/api'
export const SUMER_API_BASE_URL = 'https://api-sumer.sumer.money/api'

import * as Sumer from '@meterio/sumer-js'

export * from './multiplier'

import { monadTestnet, meterTestnet, baseSepolia, arbitrumSepolia, base, arbitrum } from 'viem/chains'

export const faucetTokens = {
  4: [
    { symbol: Sumer.USDT, balance: '100' },
    { symbol: Sumer.USDC, balance: '100' },
    { symbol: Sumer.WBTC, balance: '3' },
  ],
  322: [
    { symbol: Sumer.USDT, balance: '100' },
    { symbol: Sumer.USDC, balance: '100' },
    { symbol: Sumer.BTCK, balance: '3' },
  ],
  321: [
    { symbol: Sumer.USDT, balance: '100' },
    { symbol: Sumer.USDC, balance: '100' },
    { symbol: Sumer.BTCK, balance: '3' },
  ],
  83: [
    { symbol: Sumer.MTR, balance: '20' },
    { symbol: Sumer.USDT, balance: '100' },
    { symbol: Sumer.USDC, balance: '100' },
    { symbol: Sumer.ETH, balance: '50' },
    { symbol: Sumer.BTC, balance: '3' },
    // { symbol: Sumer.BUSD, balance: '100' }
  ],
  84531: [
    { symbol: Sumer.USDT, balance: '100' },
    { symbol: Sumer.USDC, balance: '100' },
    { symbol: Sumer.BTC, balance: '3' },
  ],
  11155111: [
    { symbol: Sumer.USDT, balance: '100' },
    { symbol: Sumer.USDC, balance: '100' },
    { symbol: Sumer.BTC, balance: '3' },
  ],
  280: [
    { symbol: Sumer.BTC, balance: '3' },
    { symbol: Sumer.USDC, balance: '100' },
    { symbol: Sumer.DAI, balance: '100' },
    { symbol: Sumer.LINK, balance: '100' },
  ],
}

const { VUE_APP_PRODUCTION } = process.env

console.log('process.env.NODE_ENV', process.env.NODE_ENV)

export const getGroups = (chainId) => {
  const groups = [
    { id: 1, name: 'USD' }, // USD
    { id: 2, name: 'ETH' }, // ETH
    { id: 3, name: 'BTC' }, // BTC
  ]
  if (chainId === 56) {
    groups.push({ id: 5, name: 'BTC LST' })
  }
  if (chainId === 1) {
    groups.push({ id: 4, name: 'BTC Looping' })
  } else if (chainId === 80084) {
    groups.push({ id: 4, name: 'Others' })
  } else {
    groups.push({ id: 4, name: 'Others' })
  }
  return groups
}

export const StayNetworkId = '' //43111
export const StayTip = 'Hemi is currently only supported for suToken bridging'

export const stayNetworkList = [
  {
    networkId: 43111,
    name: 'Hemi',
    nameInCompoundjs: 'hemi',
    symbol: 'ETH',
    symbolName: 'ETH',
    decimals: 18,
    rpc: 'https://rpc.hemi.network/rpc',
    readRpc: 'https://rpc.hemi.network/rpc',
    blockExplorer: 'https://explorer.hemi.xyz',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/43111`,
    ccipBridge: '',
    ccipChainSelector: '',
    oftBridge2: {
      eid: 30329,
      epointAddr: '0x6F475642a6e85809B1c36Fa62763669b1b48DD5B',
      proxyAddr: '0x30E148a79B898EFa1Ab1285F5Eca71972a7e0acE',
      timelockAddr: '0xB325BBf765ff4e65D38BA045D925b80B52f1A37C',
      GAS_LIMIT: {
        Max: 270000,
        Min: 150000,
      },
      MSG_VALUE: 0,
    },
  },
]

// support network list for switch network
export const supportNetworkList = [
  {
    networkId: 82,
    name: 'Meter',
    nameInCompoundjs: 'metermain',
    symbol: 'MTR',
    symbolName: 'MTR',
    decimals: 18,
    rpc: 'https://rpc.meter.io',
    readRpc: 'https://rpc.meter.io',
    blockExplorer: 'https://scan.meter.io',
    liquidationBaseUrl:`${SHYLOCK_BASE_URL}/82`,
    ccipBridge: '',
    ccipChainSelector: '',
    oftBridge2: {
      eid: 30176,
      epointAddr: '0xef02BacD67C0AB45510927749009F6B9ffCE0631',
      proxyAddr: '0xDf991dD5B8473c31F33BB2e7c5bae25ADb23be5b',
      timelockAddr: '0xcD1891126de5A64F58769df9Fe42b25df9f1bE1A',
      GAS_LIMIT: {
        Max: 270000,
        Min: 150000,
      },
      MSG_VALUE: 0,
    },
  },
  {
    networkId: 80094,
    name: 'Bera',
    nameInCompoundjs: 'beramain',
    symbol: 'BERA',
    symbolName: 'BERA',
    decimals: 18,
    rpc: 'https://rpc.berachain.com',
    readRpc: 'https://rpc.berachain.com',
    readRpcBack: 'https://rpc.berachain-apis.com',
    blockExplorer: 'https://berascan.com',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/80094`,
    ccipBridge: '',
    ccipChainSelector: '',
    oftBridge2: {
      eid: 30362,
      epointAddr: '0x6F475642a6e85809B1c36Fa62763669b1b48DD5B',
      proxyAddr: '0xddab3eb6028a44Fb31F9Da92eA1608809248B6b3',
      timelockAddr: '0x3C752d0D78BbFddA6BF4b6000a01228B732441aE',
      GAS_LIMIT: {
        Max: 270000,
        Min: 150000,
      },
      MSG_VALUE: 0,
    },
  },
  {
    networkId: 1,
    name: 'Ethereum',
    nameInCompoundjs: 'ethereum',
    symbol: 'ETH',
    symbolName: 'ETH',
    decimals: 18,
    rpc: 'https://eth.llamarpc.com',
    readRpc: 'https://eth-mainnet.public.blastapi.io',
    blockExplorer: 'https://etherscan.io',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/1`,
    _ccipBridge: '0x59dF33EBf2101d93d2878a82ad1A0959a58bCcEB',
    _ccipChainSelector: '5009297550715157269',
  },
  {
    networkId: 42161,
    name: 'Arbitrum',
    nameInCompoundjs: 'arbitrum',
    symbol: 'ETH',
    symbolName: 'ETH',
    decimals: 18,
    rpc: 'https://arbitrum.llamarpc.com',
    readRpc: 'https://arbitrum-one.public.blastapi.io',
    blockExplorer: 'https://arbiscan.io',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/42161`,
    ccipBridge: '0x12330179cF1168fF6aAC765A8BeAaF7eD8C0459D',
    ccipChainSelector: '4949039107694359620',
    oftBridge2: {
      eid: 30110,
      epointAddr: '0x1a44076050125825900e736c501f859c50fE728c',
      proxyAddr: '0x2AAB35C5Abc6895AD56Fd91A0F0001682c8d3bE5',
      timelockAddr: '0xd3F301fB91b77D9fE84B7fFc2213F2fA61F09Cb1',
      GAS_LIMIT: {
        Max: 270000,
        Min: 150000,
      },
      MSG_VALUE: 0,
    },
    // omni: {
    //   assets: ['USDC'],
    //   viemChain: arbitrum
    // }
  },
  {
    networkId: 8453,
    name: 'Base',
    nameInCompoundjs: 'basemain',
    symbol: 'ETH',
    symbolName: 'ETH',
    decimals: 18,
    rpc: 'https://base.publicnode.com',
    readRpc: 'https://base-mainnet.public.blastapi.io',
    blockExplorer: 'https://basescan.org',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/8453`,
    ccipBridge: '0x7FaeB1dD9E35603dfE427149B809271ea845d579',
    ccipChainSelector: '15971525489660198786',
    oftBridge2: {
      eid: 30184,
      epointAddr: '0x1a44076050125825900e736c501f859c50fE728c',
      proxyAddr: '0xcFA2aAF148Cd8Bf82A696c7e43610Cd46Db52592',
      timelockAddr: '0x393f5731d146343060df19A6132E651e401b4D40',
      GAS_LIMIT: {
        Max: 270000,
        Min: 150000,
      },
      MSG_VALUE: 0,
    },
    // omni: {
    //   assets: ['USDC'],
    //   viemChain: base
    // }
  },
  // {
  //   networkId: 810180,
  //   name: 'zkLink Nova',
  //   nameInCompoundjs: 'zklink',
  //   symbol: 'ETH',
  //   symbolName: 'ETH',
  //   decimals: 18,
  //   rpc: 'https://rpc.zklink.io',
  //   readRpc: 'https://rpc.zklink.io',
  //   blockExplorer: 'https://explorer.zklink.io',
  //   liquidationBaseUrl: 'https://api-shylock.sumer.money/api/810180',
  //   ccipBridge: '',
  //   ccipChainSelector: '',
  //   subgraph: 'https://graph.zklink.io/subgraphs/name/sumer-points',
  //   oftBridge2: {
  //     eid: 30301,
  //     epointAddr: '0x5c6cfF4b7C49805F8295Ff73C204ac83f3bC4AE7',
  //     proxyAddr: '0xaf255d8Edc3ba9F1508e5eE03e40020A18dF06eb',
  //     timelockAddr: '0xB9e21067eF8CEe518F1F59Ea73b369DD1650f2a5',
  //     GAS_LIMIT: {
  //       Max: 500000,
  //       Min: 220000
  //     },
  //     MSG_VALUE: 0
  //   }
  // },
  {
    networkId: 56,
    name: 'BNB Smart Chain',
    nameInCompoundjs: 'bsc',
    symbol: 'BNB',
    symbolName: 'BNB',
    decimals: 18,
    rpc: 'https://bscrpc.com',
    readRpc: 'https://bsc-mainnet.public.blastapi.io',
    blockExplorer: 'https://bscscan.com',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/56`,
    ccipBridge: '',
    ccipChainSelector: '11344663589394136015',
  },
  // {
  //   networkId: 223,
  //   name: 'B² Network',
  //   nameInCompoundjs: 'b2main',
  //   symbol: 'BTC',
  //   symbolName: 'BTC',
  //   decimals: 18,
  //   rpc: 'https://rpc.bsquared.network',
  //   readRpc: 'https://rpc.bsquared.network',
  //   blockExplorer: 'https://explorer.bsquared.network',
  //   liquidationBaseUrl: 'https://api-shylock.sumer.money/api/223',
  //   ccipBridge: '',
  //   ccipChainSelector: '',
  //   subgraph: 'https://graph-b2.meter.io/subgraphs/name/meterio/sumer',
  // },
  // {
  //   networkId: 4200,
  //   name: 'Merlin Mainnet',
  //   nameInCompoundjs: 'merlin',
  //   symbol: 'BTC',
  //   symbolName: 'BTC',
  //   decimals: 18,
  //   rpc: 'https://rpc.merlinchain.io',
  //   readRpc: 'https://rpc.merlinchain.io',
  //   blockExplorer: 'https://scan.merlinchain.io',
  //   liquidationBaseUrl: 'https://api-shylock.sumer.money/api/4200',
  //   ccipBridge: '',
  //   ccipChainSelector: '',
  //   subgraph: 'https://api.goldsky.com/api/public/project_cm3836ppph1wz01yn6kwjhits/subgraphs/sumer-merlin/1.0.0/gn',
  // },
  {
    networkId: 1116,
    name: 'CoreDAO',
    nameInCompoundjs: 'core',
    symbol: 'CORE',
    symbolName: 'CORE',
    decimals: 18,
    rpc: 'https://rpc.coredao.org',
    readRpc: 'https://rpc.coredao.org',
    blockExplorer: 'https://scan.coredao.org',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/1116`,
    ccipBridge: '',
    ccipChainSelector: '',
    oftBridge2: {
      eid: 30153,
      epointAddr: '0x1a44076050125825900e736c501f859c50fE728c',
      proxyAddr: '0x873449359d2d99691436E724C6C219a39b159B4a',
      timelockAddr: '0xc538166A773b22c60ed3b3E343E506F3fdAe0555',
      GAS_LIMIT: {
        Max: 270000,
        Min: 150000,
      },
      MSG_VALUE: 0,
    },
  },
  {
    networkId: 200901,
    name: 'Bitlayer',
    nameInCompoundjs: 'bitlayer',
    symbol: 'BTC',
    symbolName: 'BTC',
    decimals: 18,
    rpc: 'https://rpc.ankr.com/bitlayer',
    readRpc: 'https://rpc.ankr.com/bitlayer',
    blockExplorer: 'https://www.btrscan.com',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/200901`,
    ccipBridge: '',
    ccipChainSelector: '',
  },
  {
    networkId: 2345,
    name: 'GOAT Network',
    nameInCompoundjs: 'goat',
    symbol: 'BTC',
    symbolName: 'BTC',
    decimals: 18,
    rpc: 'https://rpc.goat.network',
    readRpc: 'https://rpc.goat.network',
    blockExplorer: 'https://explorer.goat.network',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/2345`,
    ccipBridge: '',
    ccipChainSelector: '',
    subgraph: 'https://api.goat.0xgraph.xyz/api/public/1a46612b-e59f-4675-8d8b-5775d0e765b3/subgraphs/sumer-goat/v0.0.1/gn'
  },
  {
    networkId: 10143,
    name: 'Monad Testnet',
    nameInCompoundjs: 'monadtest',
    symbol: 'MON',
    symbolName: 'MON',
    decimals: 18,
    rpc: 'https://testnet-rpc.monad.xyz',
    readRpc: 'https://testnet-rpc.monad.xyz',
    blockExplorer: 'https://testnet.monadexplorer.com',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/10143`,
    isTestnet: true,
    ccipBridge: '',
    ccipChainSelector: '',
  },
  {
    networkId: 83,
    name: 'Meter Testnet',
    nameInCompoundjs: 'metertest',
    symbol: 'MTR',
    symbolName: 'MTR',
    decimals: 18,
    rpc: 'https://rpctest.meter.io',
    readRpc: 'https://rpctest.meter.io',
    blockExplorer: 'https://scan-warringstakes.meter.io',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/83`,
    isTestnet: true,
    ccipBridge: '',
    ccipChainSelector: '',
    oftBridge2: {
      eid: 40156,
      epointAddr: '0x3E03163f253ec436d4562e5eFd038cf98827B7eC',
      proxyAddr: '0xB41a27CEa6535C8D972607f9Bc81590C409Ab8f2',
      timelockAddr: '0xF7Ad5941f9AE81Ba396b95079c59Ab766C2bB34e',
      GAS_LIMIT: {
        Max: 250000,
        Min: 100000,
      },
      MSG_VALUE: 0,
    },
  },
  {
    networkId: 11155111,
    name: 'Sepolia Testnet',
    nameInCompoundjs: 'sepolia',
    symbol: 'ETH',
    symbolName: 'ETH',
    decimals: 18,
    rpc: 'https://eth-sepolia.public.blastapi.io',
    readRpc: 'https://ethereum-sepolia-rpc.publicnode.com',
    blockExplorer: 'https://sepolia.etherscan.io',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/11155111`,
    isTestnet: true,
    ccipBridge: '0x2fF01f01a50E55aB7349DD637BB2229cBBe30B89',
    ccipChainSelector: '16015286601757825753',
    oftBridge2: {
      eid: 40161,
      epointAddr: '0x6EDCE65403992e310A62460808c4b910D972f10f',
      proxyAddr: '0xeEA94706C3F4760c6EED7590a53D8F394685817a',
      timelockAddr: '0x773b5cDf58eaE454ca72DCdBb9B957f0e5b709d8',
      GAS_LIMIT: {
        Max: 250000,
        Min: 150000,
      },
      MSG_VALUE: 0,
    },
  },
  {
    networkId: 84532,
    name: 'Base Sepolia Testnet',
    nameInCompoundjs: 'basesepolia',
    symbol: 'ETH',
    symbolName: 'ETH',
    decimals: 18,
    rpc: 'https://sepolia.base.org',
    readRpc: 'https://sepolia.base.org',
    blockExplorer: 'https://sepolia.basescan.org',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/84532`,
    isTestnet: true,
    ccipBridge: '',
    ccipChainSelector: '',
    omni: {
      assets: ['USDC'],
      viemChain: baseSepolia
    }
  },
  {
    networkId: 421614,
    name: 'Arbitrum Sepolia',
    nameInCompoundjs: 'arbitrumsepolia',
    symbol: 'ETH',
    symbolName: 'ETH',
    decimals: 18,
    rpc: 'https://sepolia-rollup.arbitrum.io/rpc',
    readRpc: 'https://sepolia-rollup.arbitrum.io/rpc',
    blockExplorer: 'https://sepolia.arbiscan.io',
    liquidationBaseUrl: `${SHYLOCK_BASE_URL}/421614`,
    isTestnet: true,
    ccipBridge: '',
    ccipChainSelector: '',
    omni: {
      assets: ['USDC'],
      viemChain: arbitrumSepolia
    }
  },
]

export const getNetworkConfig = (chainId) => {
  let chainIdNum = 0
  if (typeof chainId === 'number') {
    chainIdNum = chainId
  } else if (typeof chainId === 'string' && chainId.startsWith('0x')) {
    chainIdNum = Number(chainId.at, 16)
  } else {
    throw new Error(`invalid chainId ${chainId}`)
  }
  for (const c of supportNetworkList) {
    if (c.networkId === chainIdNum) {
      return c
    }
  }
  console.log(`could not find network config for chainId ${chainId}, return default meter network.`)
  return supportNetworkList.find((net) => net.networkId === 82)
  // throw new Error(`could not find network config for chainId ${chainId}`)
}

export const getSupportNetwork = () => {
  const lists = [...supportNetworkList, ...stayNetworkList]
  // console.log('VUE_APP_PRODUCTION', VUE_APP_PRODUCTION)
  // if (VUE_APP_PRODUCTION === 'true') {
  //   return lists.filter((net) => !net.isTestnet || [83, 80084, 10143].includes(net.networkId))
  // }
  return lists
}

export const getSupportNetworksById = (networkId) => {
  const net = supportNetworkList.find((net) => net.networkId === networkId)
  if (net) {
    return supportNetworkList.filter((ne) => !ne.isTestnet === !net.isTestnet)
  }
  return []
}

export const links = [
  {
    href: 'https://sumer.money',
    name: 'About',
  },
  {
    href: 'https://docs.sumer.money',
    name: 'Docs',
  },
  {
    href: 'https://twitter.com/SumerMoney',
    name: 'Twitter',
  },
  {
    href: 'https://discord.gg/ggYBw8EuaN',
    name: 'Discord',
  },
]

export const FailureTopic = '0x45b96fe442630264581b197e84bbada861235052c5a1aadfff9ea4e40a969aa0'

export const upgradingNetwork = []

const ptweEthArb26SEP2024 = '0xb8b0a120F6A68Dd06209619F62429fB1a8e92feC'.toLowerCase()
const ptRsEthArb26SEP2024 = '0x30c98c0139B62290E26aC2a2158AC341Dcaf1333'.toLowerCase()
const ptweEthArb26DEC2024 = '0xE2B2D203577c7cb3D043E89cCf90b5E24d19b66f'.toLowerCase()
const ptRsEthArb26DEC2024 = '0x355ec27c9d4530dE01A103FA27F884a2F3dA65ef'.toLowerCase()

export const ArbPTTokens = [
  // ptweEthArb26SEP2024, ptRsEthArb26SEP2024,
  // ptweEthArb26DEC2024, ptRsEthArb26DEC2024
]
export const ArbGasToken = '0x912CE59144191C1204E64559FE8253a0e49E6548'.toLowerCase()

export const SecondsPerYear = 60 * 60 * 24 * 365

export const sdrUSDC_HONEY_BEX = '0x341fDb6532154Cec491Aca3D3BB404C2d4cc042E'.toLowerCase()
